var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRowCropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49895 0C3.80597 0 0 3.80597 0 8.50105C0 10.6253 0.780067 12.5691 2.0676 14.0601V14.0643H2.07179C3.62983 15.8635 5.93228 17.0021 8.49895 17.0021C13.194 17.0021 17 13.1961 17 8.50105C17 3.80597 13.194 0 8.49895 0ZM8.49895 1.33366C12.4517 1.33366 15.6663 4.54829 15.6663 8.50105C15.6663 8.91834 15.6286 9.32515 15.5594 9.72357H12.6635V6.30973L14.0412 4.93203L13.0976 3.98841L11.9799 5.10608L10.8937 4.01986L9.95004 4.96349L11.3277 6.34119V9.72567H9.15949V8.31023L10.5665 6.90317L9.62292 5.95954L8.50524 7.07722L7.41692 5.9889L6.47329 6.93253L7.82373 8.28297V9.72567H5.7142V6.30973L7.0919 4.93203L6.14827 3.98841L5.03269 5.10398L3.94647 4.01776L3.00284 4.96139L4.38054 6.33909V9.72357H1.44061C1.37141 9.32725 1.33366 8.91834 1.33366 8.50105C1.33366 4.54829 4.54829 1.33366 8.49895 1.33366ZM9.15949 12.7285V11.0551H15.1945C14.9639 11.6549 14.6556 12.2169 14.2823 12.7285H9.15949ZM2.71765 12.7285C2.3423 12.2189 2.03614 11.657 1.80548 11.0551H7.82583V12.7285H2.71765ZM3.98631 14.0622H13.0116C11.7786 15.0645 10.208 15.6663 8.49895 15.6663C6.78993 15.6663 5.21932 15.0645 3.98631 14.0622Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowCropIcon);
export default __webpack_public_path__ + "static/media/rowCropIcon.d7b9e3ff5260fea4a127b5857a3735f8.svg";
export { ForwardRef as ReactComponent };